export default function ViewNavigate(navigate,newRoute) {
  const handleNavigation = () => {
    if (!document.startViewTransition) {
      return navigate(newRoute);
    } else {
      return document.startViewTransition(() => {
        navigate(newRoute);
      });
    }
  };
  return handleNavigation;
}